var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"table-box"},[_c('loading',{attrs:{"isShow":_vm.listLoading}}),_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.tableData},scopedSlots:_vm._u([{key:"min",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [(row.min == row.max || row.min == 0)?_c('span',[_vm._v(_vm._s(row.max)+"%")]):_c('span',[_vm._v(_vm._s(row.min)+"%-"+_vm._s(row.max)+"%")])]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('div',[_c('span',{staticClass:"table-btn",on:{"click":function($event){return _vm.edit(row)}}},[_vm._v("详情")])])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }